module.exports = __webpack_public_path__ + "img/quest_icon_0075_money.05847b10.png";